export enum PopupDirection {
    above = 'ABOVE',
    below = 'BELOW',
    right = 'RIGHT',
    left = 'LEFT',
    none = 'NONE',
}
